import React from "react";
import PropTypes from "prop-types";
import { Box, Chip, Tooltip } from "@mui/material";

export default function TestingRsvpChips({ attendeesCount, rsvpZugesagt, rsvpAbgesagt, rsvpAusstehend }) {
  if (attendeesCount <= 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 0.7,
        mt: 0.2,
      }}
    >
      <Tooltip title="Kandidaten mit bestätigter Teilnahme" placement="top">
        <Chip
          size="small"
          color="success"
          variant={rsvpZugesagt > 0 ? "filled" : "outlined"}
          label={`✓ ${rsvpZugesagt} Zugesagt`}
        />
      </Tooltip>

      <Tooltip title="Kandidaten mit Absage" placement="top">
        <Chip
          size="small"
          color="error"
          variant={rsvpAbgesagt > 0 ? "filled" : "outlined"}
          label={`✗ ${rsvpAbgesagt} Abgesagt`}
        />
      </Tooltip>

      <Tooltip title="Kandidaten ohne Rückmeldung" placement="top">
        <Chip
          size="small"
          color="warning"
          variant={rsvpAusstehend > 0 ? "filled" : "outlined"}
          label={`⧗ ${rsvpAusstehend} Ausstehend`}
        />
      </Tooltip>
    </Box>
  );
}

TestingRsvpChips.propTypes = {
  attendeesCount: PropTypes.number,
  rsvpZugesagt: PropTypes.number,
  rsvpAbgesagt: PropTypes.number,
  rsvpAusstehend: PropTypes.number,
};

TestingRsvpChips.defaultProps = {
  attendeesCount: 0,
  rsvpZugesagt: 0,
  rsvpAbgesagt: 0,
  rsvpAusstehend: 0,
};
